import React from "react";

// Styles
import styles from "./TryPollDialog.module.css";

// Components
import QuestionsForm from "../../UI/QuestionsForm/QuestionsForm";
import PollInfoPanel from "../PollInfoPanel/PollInfoPanel";

// Interfaces
import { Poll, PollQuestion } from "../../../interfaces/Poll";
import { Score } from "../../../interfaces/Score";

// Language
import { useTranslation } from "react-i18next";

// Hook
import { useTryPoll } from "../../../hooks/useTryPoll";
import { useSimulateInquiryAlerts } from "../../../hooks/useSimulateInquiryAlerts";

// TryPollDialog: Dialog that renders a test or a poll. The user can answer
// both the multi-answer and the free text questions. Props:
//  -poll: poll object
//  -questions: array of all the questions of the poll
//  -score: score object (if any)
//  -showModal: function that closes the modal when set to false.
const TryPollDialog: React.FC<{
  poll: Poll;
  questions: PollQuestion[];
  score: Score | undefined;
  showModal: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({ poll, questions, score, showModal }) => {
  
  const { t } = useTranslation();

  const { answers, result, updateAnswer } = useTryPoll(questions);
  const { alertsMessages } = useSimulateInquiryAlerts(answers, questions);

  return (
    <div className={`${styles.tryPollDialog} dialog`}>
      {/* Header */}
      <div className={styles.header}>
        <h1 className="dialogTitle">{t("try_poll")}</h1>
        <h2 className={styles.subtitle}>{poll.name}</h2>
      </div>

      {/* Content */}
      <div className={styles.contentContainer}>
        <div className={styles.leftArea}>
          <PollInfoPanel
            poll={poll}
            answers={answers}
            result={result}
            score={score}
            alertsMessages={alertsMessages}
          />
        </div>

        <div className={styles.rightArea}>
          <QuestionsForm questions={questions} updateAnswer={updateAnswer} />
        </div>
      </div>

      {/* Footer */}
      <div className={styles.bottomDialog}>
        <button className={styles.buttonClose} onClick={() => showModal(false)}>
          {t("close")}
        </button>
      </div>
    </div>
  );
};

export default TryPollDialog;
